import Grid from '@componentPrimitives/Grid';
import BlockHeader from '@components/BlockHeader';
import { BlockContainer } from '@components/Blocks';
import Image from '@components/Image/Image';
import Link from '@components/Link';
import { createBlock } from '@lib/features/blocks/blocks';

const ImageGalleryBlock = createBlock<'blocks_imageGallery_BlockType'>(
  ({ heading, content, nColumns, children = [] }) => {
    const colWidth = (12 / (nColumns ?? 2)) as 6 | 4 | 3;

    return (
      <BlockContainer maxWidth="md">
        <BlockHeader
          {...{
            heading,
            HeadingProps: { variant: 'h6' },
            content,
          }}
        />
        <Grid rowGutter cx={{ justifyContent: 'center' }}>
          {children?.map((v, i) => (
            <Grid.Col key={i} xs={6} md={colWidth}>
              {v.websiteUrl ? (
                <Link href={v.websiteUrl} target="_blank">
                  <Image ratio="landscape" contain alt="" {...v.image} />
                </Link>
              ) : (
                <Image alt="" ratio="landscape" contain {...v.image} />
              )}
            </Grid.Col>
          ))}
        </Grid>
      </BlockContainer>
    );
  }
);

export default ImageGalleryBlock;
